import { render, staticRenderFns } from "./IotHubListForm.vue?vue&type=template&id=31c60da4&"
import script from "./IotHubListForm.vue?vue&type=script&lang=js&"
export * from "./IotHubListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports